export const getNormalization = (state) => state.normalization
